import { type TOptional } from '@/types/common';

import { type TSerializedError } from './types';

const defaultErrorToJson = (error: TOptional<Error>): TOptional<TSerializedError> => {
  if (error) {
    const { cause, message, name, stack } = error;
    return { ...error, cause, message: message || `${error}`, name, stack };
  }
};

export default defaultErrorToJson;
